export default "__VITE_ASSET__gB1ChtEW__"